import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { WarehouseResource } from "@exonn/js-sdk";

export const module: ModuleOptions<WarehouseResource> = {
  resource: ResourceEnum.Warehouse,
  bigIcon: <i className={"icon-20-storage_adm"} />,
  smallIcon: <i className={"icon-15-storage_adm"} />,

  formTabs: {
    general: {
      title: (t) => t("formTabs.general.title"),
    },
    storageSchema: {
      title: (t) => t("formTabs.storageScheme.title"),
      routeObject: {
        lazy: () =>
          import(
            "src/admin/modules/warehouse/routes/edit/tabs/storage-scheme/storage-scheme.route.tsx"
          ),
      },
    },
  },
};
